import {
	adminMixin
} from '../admin/mixin'

export const liutiMixin = {
	data() {
		let data = adminMixin.data()
		data.bottomZeroRecommendLevel = ['全国仓', '定制']
		data.bottomZeroName = []
		data.bottomZeroNameKeywords = ['定制',"LX","不用"]
		data.bottomZeroCodeKeywords = []
		data.bottomZeroModelKeywords = ['定制',"LX","不用"]
		data.bottomtopratio = 3
		data.param = {
			a30: 1.2,
			a60: 0.4,
			a90: 0.6,
			level: {
				s: {
					count: 18,
					weightingamount: 4000,
					purchasingcost: 2000,
				},
				a: {
					count: 8,
					weightingamount: 1200,
					purchasingcost: 600,
				},
				b: {
					count: 3,
					weightingamount: 400,
					purchasingcost: 200,
				},
				c: {
					count: 1,
					weightingamount: 0,
					purchasingcost: 80,
				}
			}
		}
		data.delta = {
			s: {
				money: 5000,
				counta: 4,
			},
			a: {
				money: 480,
				counta: 3,
			},
			b: {
				money: 240,
				counta: 2,
			},
			c: {
				money: 120,
				counta: 1.5,
			}
		}
		return data
	},
	methods: {
		...adminMixin.methods,
		getlevel(row) {
			let isZeroRecommendlevel = false
			this.bottomZeroRecommendLevel.forEach((item) => {
				if (row.oldlevel && row.oldlevel.indexOf(item) !== -1) {
					isZeroRecommendlevel = row.oldlevel
				}
			})
			if (isZeroRecommendlevel) {
				return isZeroRecommendlevel
			}
			
			this.bottomZeroModelKeywords.forEach((item) => {
				if (row.model && row.model.indexOf(item) !== -1) {
					isZeroRecommendlevel = '定制'
				}
			})
			if (isZeroRecommendlevel) {
				return isZeroRecommendlevel
			}
			
			let level = this.param.level
			for (let i in level) {
				if(i.toUpperCase() !='C'){
					if (row.count180 >= level[i].count && row.weightingamount >= level[i].weightingamount && row
						.purchasingcost >= level[i].purchasingcost) {
						return i.toUpperCase()
					}
				}else{
					if (row.count180 >= level[i].count && row.weightingamount >= level[i].weightingamount && row
						.cost <= level[i].purchasingcost) {
						return i.toUpperCase()
					}
				}
		
			}
			return 'D'
		},
		// getbottom(row) {
		// 	let bottom = 0
		// 	let money = 0
		// 	let counta = 100
		// 	for (let i in this.delta) {
		// 		if (row.level == i.toUpperCase()) {
		// 			money = this.delta[i].money
		// 			counta = this.delta[i].counta
		// 		}
		// 	}
		// 	row.nDaySale = row.weightingsize / counta
		// 	row.nDaySale = Math.ceil(row.nDaySale)
		// 	row.nDay = this.days / counta

		// 	if (row.level == "S") {
		// 		bottom = Math.max(money / row.purchasingcost, row.weightingsize / counta)
		// 	}
		// 	if (row.level == "A" || row.level == "B" || row.level == "C") {
		// 		bottom = Math.min(money / row.purchasingcost, Math.max(money / 2 / row.purchasingcost, row
		// 			.weightingsize /
		// 			counta))
		// 	}
			
			
			
		// 	console.log(money,counta,row.purchasingcost,row.weightingsize,row.level,bottom)
		// 	return this.adjustBottom(row, bottom)
		// },
		getbottom(row) {
			let bottom = 0
			let money = 0
			let counta = 100
			for (let i in this.delta) {
				if (row.level == i.toUpperCase()) {
					money = this.delta[i].money
					counta = this.delta[i].counta
				}
			}
			row.nDaySale = row.weightingsize / counta
			row.nDaySale = Math.ceil(row.nDaySale)
			row.nDay = this.days / counta
		
			if (row.level == "S") {
				bottom = Math.min(money / row.cost, row.weightingsize / counta)
			}
			if (row.level == "A" || row.level == "B" || row.level == "C") {
				bottom = Math.min(money / row.cost, Math.max(money / 2 / row.cost, row
					.weightingsize /
					counta))
			}
			
			
			
			// console.log(money,counta,row.cost,row.weightingsize,row.level,bottom)
			return this.adjustBottom(row, bottom)
		},
		getcorrectbottom() { //最大下限5不超过50kg
			// let correctbottom = 999999
			// if (row.weight && row.weight != 0) {
			// 	correctbottom = parseInt(50 / row.weight)
			// }

			return 999999
		},
		getwarehouseConfig(row) {
			let bottom = row.bottom
			let totalcount = 0
			let totalsize = 0
			let alpha = 1
			if (!row.warehouse || !row.warehouse.length) {
				row.warehouse = [{
					id: 0,
					code: row.code,
					count: 1,
					size: 1,
					customtop : 0,
					custombottom : 0,
					storageID: "2B5977B052DF348DB4B07D8C1D5E0200",
					storage_name: "滨海新仓",
					getday: 0
				}]
			}



			row.warehouse.forEach((item) => {
				totalcount += parseInt(item.count)
				totalsize += parseInt(item.size)
			})
			if (row.warehouse.length == 2) {
				alpha = 0.6
			}
			if (row.warehouse.length == 3) {
				alpha = 0.5
			}
			if (row.warehouse.length == 4) {
				alpha = 0.4
			}
			if (row.warehouse.length == 0) {
				row.warehouse = JSON.parse(JSON.stringify(row.oldwarehousebt))
			}
			row.warehouse.forEach((item) => {
				if (row.level == 'D') {
					item.percent = 0
					item.bottom = 0
					item.top = 0
					if (parseFloat(row.purchasingcost)) {
						item.top = 120 / row.purchasingcost
					}
				} else {
					if (totalcount == 0 || totalsize == 0) {
						item.percent = 0
					} else {
						item.percent = (item.count / totalcount * 0.5 + item.size / totalsize * 0.5) * row
							.warehouse.length * alpha
					}
					item.percent = Math.max(Math.min(item.percent, 1), 0)
					item.percent = item.percent ? item.percent : 0
					item.bottom = row.bottom * item.percent
					item.bottom = Math.min(item.bottom, row.correctbottom)
					item.bottom = Math.ceil(item.bottom)
					item.bottom = item.bottom ? item.bottom : 0


					if (item.getday && item.getday > 2) {
						item.bottom = item.bottom * (1 + item.getday / this.days)
						item.bottom = Math.ceil(item.bottom)
					}
					item.top = item.bottom + bottom * 3

				}
		
				item.top = Math.floor(item.top)


				row.oldwarehousebt.forEach((_item) => {
					if (_item.storageID == item.storageID) {
						item.oldbottom = _item.bottom
						item.oldtop = _item.top
						item.customtop = _item.customtop
						item.custombottom = _item.custombottom
					}
				})
				// if (row.oldlevel == '新品') {
				// 	if ((Math.floor(Date.now() / 1000) - row.create_time) <= 86400 * 90) {
				// 		if (item.oldbottom >= item.bottom) {
				// 			item.bottom = item.oldbottom
				// 			item.top = item.oldtop
				// 			row.level = '新品'
				// 		}
				// 	}
				// }

				if (this.bottomZeroName.indexOf(row.name) !== -1) {
					item.percent = 0
					item.bottom = 0
					item.top = 0
				}
				if (item.bottom > item.top) {
					item.bottom = 0
					item.top = 0
				}

			})

			row.oldwarehousebt.forEach((item) => {
				let obj = row.warehouse.find((_item) => {
					return _item['storageID'] == item['storageID']
				})
				if (!obj) {
					row.warehouse.push({
						id: 0,
						code: item.goodscode,
						size: 0,
						count: 0,
						percent: 0,
						bottom: 0,
						top: 0,
						oldbottom: item.bottom,
						oldtop: item.top,
						custombottom: item.custombottom,
						customtop: item.customtop,
						storageID: item.storageID,
						storage_name: item.storage_name
					})
				}

			})
		},
	}
}